import { render, staticRenderFns } from "./transfer-dialog.vue?vue&type=template&id=a762d828&"
import script from "./transfer-dialog.vue?vue&type=script&lang=js&"
export * from "./transfer-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports